import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import Button from "components/Common/Button";
import { NO_OP_FUNCTION } from "services/helpers";
import "./style.scss";

class ButtonGroup extends React.PureComponent {
  /**
   * @returns {ReactElement}
   */
  render() {
    const {
      stopPropagation, preventDefault, data, disabled, value, className, selectedClassName, onChange
    } = this.props;

    const buttons = data.map(dataSet => (
      <Button
        key={dataSet.value}
        customClassName={classNames(
          "ButtonGroup__button", {
            "ButtonGroup__button--active": value === dataSet.value,
            "ButtonGroup__button--disabled": disabled,
            [selectedClassName]: value === dataSet.value
          }
        )}
        onClick={(e) => {
          if (stopPropagation) {
            e.stopPropagation();
          }

          if (preventDefault) {
            e.preventDefault();
          }

          onChange(dataSet.value);
        }}
        text={dataSet.label}
        icon={dataSet.icon}
        center={dataSet.icon}
      />
    ));

    return (
      <div className={`ButtonGroup ${className} ${disabled ? "ButtonGroup--disabled" : ""}`}>
        {buttons}
      </div>
    );
  }
}

ButtonGroup.propTypes = {
  stopPropagation: PropTypes.bool,
  preventDefault: PropTypes.bool,
  disabled: PropTypes.bool,
  data: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    icon: PropTypes.string
  })).isRequired,
  /** Active button value */ value: PropTypes.string,
  className: PropTypes.string,
  /** Active style class name */ selectedClassName: PropTypes.string,
  onChange: PropTypes.func
};

ButtonGroup.defaultProps = {
  stopPropagation: false,
  preventDefault: false,
  disabled: false,
  value: null,
  className: null,
  selectedClassName: null,
  onChange: NO_OP_FUNCTION
};

export default ButtonGroup;
